import useLocalStorageState from 'use-local-storage-state';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@startuptools/ui/Button';
import { SignupLayout } from '@startuptools/business-ui/SignupLayout';
import React from 'react';
import { I18nProvider, useLingui } from '@lingui/react';
import { I18n } from '@lingui/core';

export const WelcomeDialog = () => {
  const { i18n } = useLingui();
  const locali18nRef = React.useRef(new I18n({ locale: 'en', messages: i18n['_messages'] }));

  const [dismiss, setDismiss] = useLocalStorageState('dismiss-free-templates-dialog', {
    defaultValue: 0,
  });

  const [open, setOpen] = React.useState(dismiss < 3);

  const close = () => {
    setDismiss(dismiss + 1);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="lg"
      sx={{
        boxShadow: '0rem 0.875rem 1.5rem rgba(0, 0, 0, 0.12)',
        borderRadius: '0.25rem',
        mx: 'auto',
        my: 'auto',
      }}
    >
      <I18nProvider i18n={locali18nRef.current} /* force this content to be English*/>
        <SignupLayout contentType="platform" maxHeight={{ md: '450px' }} inDialog>
          <DialogTitle
            sx={{
              padding: '0rem 0rem 1.5rem 0rem',
              fontFamily: 'Inter',
              fontSize: '2rem',
              fontWeight: '700',
              color: 'black',
              lineHeight: '2.0625rem',
            }}
            id="alert-dialog-title"
          >
            Would you like to try our platform?
          </DialogTitle>
          <DialogContent sx={{ padding: '0rem', marginBottom: '2.5rem' }}>
            <DialogContentText sx={{ padding: '0rem', margin: '2.5rem 0' }} id="alert-dialog-description">
              We are building a better future for entrepreneurs. We provide free high quality templates as a legal
              framework and a smooth platform where you will discover how seamless taking care of your company can be.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 4,
              flexDirection: { xs: 'column', md: 'row' },
              pb: { xs: 4, md: 0 },
            }}
          >
            <Button variant="plain" color="neutral" onClick={close}>
              Skip, just download the documents
            </Button>
            <a href="/">
              <Button>Sign up for free</Button>
            </a>
          </DialogActions>
        </SignupLayout>
      </I18nProvider>
    </Dialog>
  );
};
